import script from "./SearchPageLayoutButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageLayoutButtons.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageLayoutButtons.vue?vue&type=style&index=0&id=19eeb430&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19eeb430"]])

export default __exports__